import styled from 'react-emotion';
import { Colors } from 'politico-style';

const { brand } = Colors;

const StyledButton = styled('button')`
  cursor:pointer;
  border-radius: 5px;
  color: ${brand.politicoDarkTypeGray.hex};
  transition: all .2s;
  letter-spacing: .5px;
  font-weight: 200;
  margin: 2px;
  color: white;
  font-size: 14px;
  padding: 5px 10px;
  outline: none !important;

  background-color: ${props => props.dangerous ? brand.politicoRedDark.hex : '#6c757d'};
  border:1px solid ${props => props.dangerous ? brand.politicoRedDark.hex : '#6c757d'};

  &:hover{
   box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  }
`;

export default StyledButton;
